<template>
  <v-container>
    <div class="d-flex justify-end">
      <v-breadcrumbs :items="breadItems" divider=">"></v-breadcrumbs>
    </div>
    <v-row>
      <v-col sm="12">
        <v-card class="setting-card container">
          <v-row>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <router-link
                class="profile-link"
                active-class
                :exact="true"
                :to="{ name: 'SettingClass' }"
              >
                <div class="menu-box">
                  <v-img
                    src="../../../assets/presentation.png"
                    class="menu-box__photo"
                    max-height="60px"
                    max-width="60px"
                    contain
                  ></v-img>
                  <h3 class="menu-box__title">Classes</h3>
                </div>
              </router-link>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <router-link
                class="profile-link"
                active-class
                :exact="true"
                :to="{ name: 'Users' }"
              >
                <div class="menu-box">
                  <v-icon class="drawer--nav-item__icon">fas fa-users</v-icon>

                  <h3 class="menu-box__title">Users</h3>
                </div>
              </router-link>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <router-link
                class="profile-link"
                active-class
                :exact="true"
                :to="{ name: 'Discounts' }"
              >
                <div class="menu-box">
                  <v-icon class="drawer--nav-item__icon">mdi-sale</v-icon>
                  <h3 class="menu-box__title">Discounts</h3>
                </div>
              </router-link>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <div class="menu-box" id="configuration-box"  @click="openConfigurations">
                <v-icon class="drawer--nav-item__icon">mdi-sale</v-icon>
                <h3 class="menu-box__title">Configurations</h3>
              </div>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <router-link
                class="profile-link"
                active-class
                :exact="true"
                :to="{ name: 'Roles' }"
              >
                <div class="menu-box">
                  <v-icon class="drawer--nav-item__icon">fa fa-tasks</v-icon>

                  <h3 class="menu-box__title">Roles</h3>
                </div>
              </router-link>
            </v-col>
            <v-col cols="6" sm="6" md="4" lg="4" class="d-flex justify-center">
              <router-link
                class="profile-link"
                active-class
                :exact="true"
                :to="{ name: 'UserPermissions' }"
              >
                <div class="menu-box">
                  <v-icon class="drawer--nav-item__icon">fa fa-tasks</v-icon>

                  <h3 class="menu-box__title">Permissions</h3>
                </div>
              </router-link>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Use Google's location service?</span>
        </v-card-title>
        <v-card-text v-if="configurations.length > 0">
          <v-row>
            <v-col>
              <v-text-field
                :error-messages="errors.grace_time"
                label="Grace Time Allowed"
                v-model="data.grace_time"
                :value="configurations[0].setting_value"
                required
              ></v-text-field>
              <p>Existing value : {{ configurations[0].setting_value }}</p>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field label="Legal middle name" hint="example of helper text only on focus"></v-text-field>
              </v-col> -->
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false"
            >Close</v-btn
          >
          <v-btn color="green darken-1" text @click="updateConfigurations"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import Form from "../../../utils/form";

export default {
  name: "Settings",
  components: {
    BreadCrumbs,
  },
  methods: {
    openConfigurations() {
      axios.get("configurations").then((response) => {
        console.log(response);
        this.configurations = response.data;
        this.dialog = true;
      });
    },
    updateConfigurations() {
      let form = new Form({
        ...this.data,
      });

      form
        .post("configurations/update", this.form)
        .then((response) => {
          // console.log(response)
          this.errors = {};
          // this.configurations = response.data
          this.dialog = false;

          Toast.fire({
            icon: "success",
            title: "Configurations Updated",
          });
        })
        .catch((response) => {
          console.log(response);
          // if (response.status === 400) {
          // this.errors = response.data
          // }
          // alert(response.status)
          // if (response.status === 422) {
          //    console.log(response.data)
          this.errors = response.data.errors;
          // }
          this.loading = false;
        });
    },
  },
  data() {
    return {
      dialog: false,
      errors: {},

      configurations: {},
      data: {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#configuration-box {
  cursor: pointer;
  color: #9734fa;
}
.setting-card {
  min-height: 70vh;
  background: #fff;
  box-shadow: 0px 3px 6px #2c28281c;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-box {
  background: #fafafa;
  border-radius: 10px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //   padding: 40px;
  margin-right: 15px;
  width: 162px;
  height: 162px;
}
</style>
